import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { Link, useLocation, useParams } from "react-router-dom";
import { LoggedInView } from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";
import { RequestStatus } from "../../utils/Enums";
import {updateInsuranceRate, resetUpdateInsuranceRateStatus, getCurrentInsuranceRate} from "../../store/reducers/InsuranceRatesSlice";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface ModifyInsuranceRateScreenProps {}

export interface ModifyInsuranceRateFormProps {
    name: string;
}

export const ModifyInsuranceRateScreen: React.FC<ModifyInsuranceRateScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    const { id } = useParams();

    const insuranceRateState = useAppSelector(
        (state) => state.insuranceRates
    );

    const requestStatus: RequestStatus =
        insuranceRateState.updateInsuranceRateStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Kindlustuse hinnad", url: "/insurance" },
        { text: "Kindlustuse hinna muutmine", url: `/insurance/${id}/modify` },
    ];

    useEffect(() => {
        dispatch(resetUpdateInsuranceRateStatus());
    }, [location]);

    useEffect(() => {
        dispatch(getCurrentInsuranceRate({ id }));
    }, [id]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {...insuranceRateState?.currentInsuranceRate},
        onSubmit: (values: any) => {
            dispatch(updateInsuranceRate({ id, data: values }));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && (
                <div className="message msg-ok">
                    <div>
                        <h2>Andmed muudetud</h2>
                    </div>
                </div>
            )}
            {requestStatus === RequestStatus.Failed &&
            insuranceRateState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {insuranceRateState.errors.map((error, index) => (
                            <span key={index}>
                                    {error}
                                <br />
                                </span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Kindlustuse hinna andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput
                                label="Hinnapiir"
                                name="price_limit"
                                mandatory={true}
                            />
                            <ElogInput
                                label="Hind"
                                name="price"
                                mandatory={true}
                            />
                            <ElogInput
                                label="Omavastutus"
                                name="own_responsibility"
                                mandatory={true}
                            />
                            <ElogInput
                                label="Poliisitasu"
                                name="policy_price"
                                mandatory={true}
                            />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                    <span>
                                        <strong>Sisesta</strong>
                                    </span>
                            </button>
                            <Link to="/offline-reasons">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};